import dayjs from "dayjs"
const dataTemp = {
    y: "YYYY",
    ym: "YYYY-MM",
    ymd: "YYYY-MM-DD",
    ymdh: "YYYY-MM-DD HH",
    ymdhm: "YYYY-MM-DD HH:mm",
    ymdhms: "YYYY-MM-DD HH:mm:ss",
};
export type DateFormatKey = keyof typeof dataTemp

export const formatUnix = (unix: number, tempKey: DateFormatKey) => {
    const dateInstance = dayjs.unix(unix);
    return dateInstance.format(dataTemp[tempKey]);
};
